import "../../../../src/content/christian-life-witness-course-general/christian-life-witness-course-general.scss";
import ClwcVideos from "../../../../src/content/christian-life-witness-course-general/clwcg-videos.js";
import * as React from 'react';
export default {
  ClwcVideos,
  React
};